/**
 * Client-ticket visibility + provenance (unified client chat, Nikhil
 * 2026-09-12). A ticket raised from a user's private portal "Chat" carries
 *   visibility: 'RAISER'  — only the person who raised it sees it in the
 *                           portal (the rest of the org does not); 'ORG' is
 *                           the default everyone-in-the-org ticket
 *   sourceChannelId       — the chat channel it was raised from (deep link
 *                           /home/chat?channel=<id>)
 * Pure; ticket_visibility.test.js.
 */

export const RAISER_VISIBILITY = 'RAISER';
export const ORG_VISIBILITY = 'ORG';

export const PRIVATE_LOCK_TITLE = 'Private to raiser — only the person who raised this ticket sees it in the portal';

export const is_raiser_private = (t) => !!t && t.visibility === RAISER_VISIBILITY;

/** Human label for the detail row; '' when the backend sends no visibility (older rows). */
export const visibility_label = (t) => {
    if (is_raiser_private(t)) return 'Private to raiser';
    if (t && t.visibility === ORG_VISIBILITY) return 'Whole org';
    return '';
};

/** Chat-inbox deep link to the conversation the ticket was raised from, or null. */
export const source_chat_href = (t) => {
    const id = t && t.sourceChannelId != null && String(t.sourceChannelId).trim() ? String(t.sourceChannelId).trim() : null;
    return id ? `/home/chat?channel=${encodeURIComponent(id)}` : null;
};
